<template>
  <v-sheet color="grey700" class="py-6 px-8 rounded-0">
    <div class="d-flex align-center mb-6">
      <div>
        <h4 class="text-body-2 text-uppercase primary500--text font-weight-bold">
          {{ round.rolledAt || round.lockingAt | relativeTime }}
        </h4>
        <h2 v-t="'common.games.wheel'" class="text-h5 text-uppercase font-weight-extrabold" />
        <h4 class="text-caption grey200--text font-weight-bold">
          {{ round.id }}
        </h4>
      </div>
      <v-spacer />
      <BetField v-if="round.data.field" class="flex-grow-0" :field="round.data.field" />
    </div>

    <!-- players -->
    <div v-if="players.length" class="players mb-8">
      <h4 class="text-body-2 d-flex align-center mb-2">
        <span class="text-uppercase primary500--text font-weight-bold" v-text="$tc('common.players_round', players.length)" />
        <v-spacer />
        <scrap class="text-caption" :amount="betSum" />
      </h4>
      <div
        v-for="player in players" :key="player.id"
        class="player grey600 px-3 py-2 d-flex align-center"
      >
        <UserAvatar
          :user="player.user" size="20" class="mr-2 link"
          @click.native="$userMenu.open($event, player.user)"
        />
        <Username
          class="text-body-2 grey100--text link" :user="player.user"
          @click.native="$userMenu.open($event, player.user)"
        />
        <v-spacer />
        <WheelPlayerBet class="text-body-2" :bets="player.bets" />
        <!-- <scrap class="text-caption" :amount="betSum" /> -->
      </div>
    </div>

    <!-- fairness -->
    <div class="fairness">
      <h4 v-t="'common.provably_fair'" class="text-body-2 text-uppercase blue200--text font-weight-bold mb-2" />

      <v-row dense class="mb-3">
        <v-col cols="12" md="3">
          <v-text-field
            :value="round.outcome"
            :label="$t('common.roll')"
            outlined dense readonly
            color="blue300"
            class="mb-2"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="round.fairness.solvingBlockId"
            :label="$t('common.eos_block')"
            outlined dense readonly
            color="blue300"
            class="mb-2"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="5">
          <v-text-field
            :value="new Date(round.lockingAt).toLocaleString()"
            :label="$t('page.wheel.pf.bets_locked_at')"
            outlined dense readonly
            color="blue300"
            class="mb-2"
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :value="round.fairness.hash"
            :label="$t('common.hash')"
            outlined dense readonly
            color="blue300"
            class="mb-2"
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :value="round.fairness.secret"
            :label="$t('common.secret')"
            outlined dense readonly
            color="blue300"
            class="mb-2"
            hide-details
          />
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            depressed small
            color="blue700"
            class="blue300--text rounded-0 font-weight-semibold"
            :ripple="false"
            rel="noopener noreferrer"
            target="_blank"
            :href="`https://bloks.io/block/${round.fairness.solvingBlockId}`"
          >
            <fai :icon="['fad', 'external-link']" class="mr-2" />
            <span v-t="'cta.view_eos_block'" />
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script>
import BetField from '@/views/games/Wheel/components/BetField'
import WheelPlayerBet from '@/views/games/Wheel/components/WheelPlayerBet'
import WheelPlayer from '@/store/models/games/wheel/WheelPlayer'

export default {
  components: { BetField, WheelPlayerBet },
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    round() {
      return this.payload.round
    },
    players() {
      const players = []
      const bets = this.round.data?.bets ?? {}

      for (const bet of Object.values(bets)) {
        players.push(new WheelPlayer({
          id: bet.user.steamid,
          betSum: Object.values(bet.bets).reduce((acc, v) => acc + v, 0),
          ...bet,
        }))
      }
      return players.sort((a, b) => b.betSum - a.betSum)
    },
    betSum() {
      return Object
        .values(this.players)
        .reduce((acc, v) => acc + v.betSum, 0)
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.select-box {
  word-break: break-all;
  user-select: all;
}

.players {
  overflow: auto;
  max-height: 400px;
}

.fairness ::v-deep input {
  color: grey(200);
  font-size: 12px;
}

::v-deep .bet-field {
  max-width: 64px;

  .pay-label {
    display: none;
  }
}
</style>
